import React from 'react';

export const LoginModalContext = React.createContext();
LoginModalContext.displayName = 'Login modal context provider';

export const LoginModalProvider = LoginModalContext.Provider;
